<script lang="ts">
    // Lista de opções em linhas, cada uma com título e uma explicação curta. Serve para escolher
    // (a opção atual fica destacada) e também para oferecer ações — aí cada linha tem o seu tom.
    import Fa from 'svelte-fa'
    import { faCheck } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher } from 'svelte'
    import type { ZsheetOption } from './zsheet'

    const dispatch = createEventDispatcher()

    let className: string = ''
    export { className as class }
    export let options: ZsheetOption[] = []
    export let value: any = null
    // false = lista de ações (ninguém fica marcado; só dispara o evento)
    export let selectable: boolean = true

    function choose(option: ZsheetOption) {
        if (option.disabled) return
        if (selectable) value = option.value
        dispatch('change', option.value)
    }
</script>

<div class="zoptions {className}">
    {#each options as option}
        <button
            type="button"
            class="zoption zoption-{option.tone || 'default'}"
            class:selected={selectable && option.value === value}
            disabled={option.disabled}
            on:click={() => choose(option)}
        >
            {#if option.icon}
                <span class="zoption_icon"><Fa icon={option.icon} /></span>
            {/if}
            <span class="zoption_text">
                <span class="zoption_label">{option.label}</span>
                {#if option.description}
                    <span class="zoption_desc">{option.description}</span>
                {/if}
            </span>
            {#if selectable && option.value === value}
                <span class="zoption_check"><Fa icon={faCheck} /></span>
            {/if}
        </button>
    {/each}
</div>

<style>
    /* valores base = tema escuro */
    .zoptions {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
    .zoption {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        text-align: left;
        padding: 9px 10px;
        border: 1px solid transparent;
        border-radius: 10px;
        background: #ffffff08;
        color: inherit;
        font: inherit;
    }
    .zoption:disabled {
        opacity: 0.45;
    }
    .zoption.selected {
        background: #2ecc711f;
        border-color: #2ecc7166;
    }
    .zoption-danger {
        color: #e58080;
    }
    .zoption-attention {
        color: #e8bd6a;
    }
    .zoption_icon {
        flex: 0 0 30px;
        height: 30px;
        border-radius: 50%;
        background: #ffffff12;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
    }
    .zoption-danger .zoption_icon {
        background: #e5737322;
    }
    .zoption-attention .zoption_icon {
        background: #e0a83a22;
    }
    .zoption_text {
        flex: 1 1 auto;
        min-width: 0;
    }
    .zoption_label {
        display: block;
        font-size: 14.5px;
        font-weight: 600;
        line-height: 1.25;
    }
    .zoption_desc {
        display: block;
        font-size: 12.5px;
        opacity: 0.55;
        line-height: 1.3;
        margin-top: 1px;
    }
    .zoption_check {
        flex: 0 0 auto;
        color: #2ecc71;
        font-size: 13px;
    }

    :global(.theme_light) .zoption {
        background: #f7f8fa;
    }
    :global(.theme_light) .zoption.selected {
        background: #2ecc7114;
        border-color: #2ecc7166;
    }
    :global(.theme_light) .zoption-danger {
        color: #c0392b;
    }
    :global(.theme_light) .zoption-attention {
        color: #9a6b12;
    }
    :global(.theme_light) .zoption_icon {
        background: #eceef2;
    }
</style>
